import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";

/**
 * i18next configuration
 *
 * Loading from .json files served with the app optimizes the loading time for
 * the language files. The files are loaded on demand when the language is
 * detected at launch or changed.
 *
 * TMS tools like Locize may also host translations, but because they're not served from
 * the same origin with the same cache policy we do, often times the performance of those
 * APIs are pretty bad. Because the translation triggers suspense and is designed to block
 * rendering, the delay is very noticeable.
 *
 * Locize takes 500ms+ to load a translation file on a cache miss through their Cloudfront CDN.
 */

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../locales/${language}/${namespace}.json`),
    ),
  )
  .init({
    supportedLngs: ["en-US", "ja-JP"],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    debug: import.meta.env.DEV,
    fallbackLng: "en-US",
  });

export default i18next;
